export interface BackgroundTextColor {
  text: string;
  background: string;
}
